import { render } from "./ConversationThread.vue?vue&type=template&id=5c50b9c1&scoped=true"
import script from "./ConversationThread.vue?vue&type=script&lang=js"
export * from "./ConversationThread.vue?vue&type=script&lang=js"

import "./ConversationThread.vue?vue&type=style&index=0&id=5c50b9c1&scoped=true&lang=css"

import exportComponent from "D:\\Accen_GITS\\Gestion-conge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c50b9c1"]])

export default __exports__